export default "__VITE_ASSET__BhXbzjbC__"